export enum PROCESS_FILTER_FIELDS {
	PROGRAM_ID = 'ProgramID',
	REGION = 'Region',
	COMPANY_ID = 'CompanyID',
	COMPANY_NAME = 'CompanyName',
	EMPLOYEE_STATUS = 'EmployeeStatus',
	GENERIC_1 = 'Generic1',
	GENERIC_2 = 'Generic2',
	GENERIC_3 = 'Generic3',
	GENERIC_4 = 'Generic4',
	GENERIC_5 = 'Generic5',
	GENERIC_6 = 'Generic6',
	GENERIC_7 = 'Generic7',
	GENERIC_8 = 'Generic8',
	GENERIC_9 = 'Generic9',
	GENERIC_10 = 'Generic10'
}
